import type { BoReference } from '../bos/bo-reference.js'
import type { HasId } from '../types.js'
export abstract class TrackByBasis {
	trackById(index: number, item: HasId) {
		return item?.id
	}

	trackByIndex(index: number, item: any) {
		return index
	}

	trackByItem(index: number, item: any) {
		return item
	}

	trackByAutomatic(index: number, item: any) {
		if (item?.id) return item.id
		const itemType = typeof item
		if (
			itemType == 'string' ||
			itemType == 'number' ||
			itemType == 'bigint' ||
			itemType == 'boolean'
		)
			return item
		return index
	}

	trackByBoReference(index: number, item: BoReference) {
		return item.getQualifiedTypeAndName()
	}
}
